export const DOCUMENT_TOTAL_DICTIONARY = {
  ALL_DOCUMENTS: "%SELECTED% %NUMBER_OF_ALL_DOCUMENTS% %DOCUMENT_WORD%",
  RUB_DOCUMENTS:
    "из них %RUB_DOCUMENTS_TOTAL_VALUE% %RUBLE% %DOCUMENT_WORD% на сумму %RUB_DOCUMENTS_TOTAL_VALUE%",
};

export const PLACEHOLDERS = {
  NUMBER_OF_ALL_DOCUMENTS: "%NUMBER_OF_ALL_DOCUMENTS%",
  DOCUMENT_WORD: "%DOCUMENT_WORD%",
  RUB_DOCUMENTS_TOTAL_VALUE: "%RUB_DOCUMENTS_TOTAL_VALUE%",
  AMOUNT_IN_RUB: "%AMOUNT_IN_RUB%",
  NUMBER_OF_SIGNED_DOCUMENTS: "%NUMBER_OF_SIGNED_DOCUMENTS%",
  SELECTED: "%SELECTED%",
  RUBLE: "%RUBLE%",
};
